export function setCookie(cname: string, cvalue: string, exdays: number) {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	document.cookie =
		cname + "=" + cvalue + ";expires=" + d + `;domain=.pinnacle.${window.location?.host.split(".").pop()};path=/`;
}
